import { FC } from "react";

interface AccomplishedIconSVGProps {
    className?: string;
}

const AccomplishedIconSVG: FC<AccomplishedIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.0003 15.9993L14.667 18.666L20.0003 13.3327M29.3337 15.9993C29.3337 23.3631 23.3641 29.3327 16.0003 29.3327C8.63653 29.3327 2.66699 23.3631 2.66699 15.9993C2.66699 8.63555 8.63653 2.66602 16.0003 2.66602C23.3641 2.66602 29.3337 8.63555 29.3337 15.9993Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AccomplishedIconSVG;
